import { Dialog, DialogContent, Text, Link, DialogHeader, DialogTitle } from '../../../../components/index.js'

interface Terms {
  text: string
  url: string
}

interface List {
  title: string
  list: string[]
}

interface ShippingService {
  title: string
  list: List[]
}

interface Data {
  title: string
  shippingCoupon: List
  shippingService: ShippingService
  terms: Terms
}

interface Props {
  data: Data
  onClose: () => void
  open: boolean
}

export const ShippingPolicyModal = ({ data, onClose, open }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        overlayClassName="z-[100]"
        className="tablet:top-1/2 tablet:max-w-[90vw] max-w-none rounded-t-box tablet:bottom-auto tablet:-translate-y-1/2 bg-white tablet:h-auto tablet:w-[896px] tablet:px-8 bottom-0 top-auto z-[110]  h-[calc(100vh-240px)] max-h-[80vh] translate-y-0 gap-0 overflow-hidden overflow-y-auto !py-0 px-4 [&_.dialog-close-button]:focus:!ring-0 [&_.dialog-close-icon]:!size-6 [&_.dialog-close-icon]:text-[#6D6D6F]"
      >
        <DialogHeader className="laptop:pt-4 pb-2 pt-4">
          <DialogTitle className="laptop:text-[24px] text-left text-[20px] font-bold">{data?.title}</DialogTitle>
        </DialogHeader>
        <div className="laptop:gap-8 laptop:py-8 py-6">
          <Text
            className="tablet:text-[20px] font-bold leading-[1.2] text-[#1d1d1f] text-[16px]"
            html={data?.shippingCoupon?.title}
          />
          <ul className="mt-3 grid grid-flow-row gap-[4px] font-bold leading-[1.4]">
            {data?.shippingCoupon?.list.map((item, index) => (
              <li className="flex text-[18px]" key={index}>
                <span className="text-[#86868C]">{index + 1}.</span>
                <span className="ml-[4px] font-bold text-[#86868C]">{item}</span>
              </li>
            ))}
          </ul>
          <div className="tablet:mt-[24px] mt-[16px]">
            <Text className="text-[18px] font-bold leading-[1.2]  text-[#1d1d1f]" html={data?.shippingService?.title} />
            <div className="mt-1 grid w-full tablet:grid-cols-2 gap-[12px] grid-cols-1">
              {data?.shippingService?.list.map((item, index) => (
                <div className="rounded-[12px] bg-[#EAEAEC] p-4" key={index}>
                  <Text as="p" className="text-base font-bold !leading-[1.2] text-[#1d1d1f]" html={item.title} />
                  <div className="mt-3 grid grid-flow-row">
                    {item.list.map((subItem, subIndex) => (
                      <Text as="p" className="text-base font-bold text-[#86868C]" key={subIndex}>
                        {subItem}
                      </Text>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <Link
            className="text-brand-0 mt-8 block text-[16px] font-bold leading-[1.2] underline"
            href={`${data?.terms?.url}`}
          >
            {data?.terms?.text}
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  )
}
